import React from 'react';
import SavingsGoals from './SavingsGoals';

const AccountBalances = ({ accounts, onEdit, onArchive, onAddGoal, onAddFunds }) => {
    const debitAccounts = accounts.filter(acc => acc.accountType === 'debit');
    const creditAccounts = accounts.filter(acc => acc.accountType === 'credit');
    const savingsAccounts = accounts.filter(acc => acc.accountType === 'savings');

    const AccountCard = ({ acc }) => (
        <div className="bg-gray-100 p-4 rounded-lg relative group">
            <div className="flex justify-between items-start">
                <h3 className="font-medium text-gray-800">{acc.name}</h3>
                <span className={`text-xs font-semibold px-2 py-1 rounded-full ${acc.accountType === 'credit' ? 'bg-red-200 text-red-800' : 'bg-green-200 text-green-800'}`}>{acc.accountType}</span>
            </div>
            {acc.accountType === 'credit' ? (
                <><p className="text-2xl font-semibold text-gray-900">${acc.balance.toFixed(2)}</p><p className="text-sm text-gray-500">of ${acc.creditLimit.toFixed(2)} limit</p></>
            ) : (
                <p className="text-2xl font-semibold text-gray-900">${acc.balance.toFixed(2)}</p>
            )}
            <div className="absolute top-2 right-2 flex gap-2 opacity-0 group-hover:opacity-100 transition-opacity">
                <button onClick={() => onEdit(acc)} className="p-1 bg-gray-300 rounded-full text-gray-700 hover:bg-gray-400"><svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15.232 5.232l3.536 3.536m-2.036-5.036a2.5 2.5 0 113.536 3.536L6.5 21.036H3v-3.572L16.732 3.732z" /></svg></button>
                <button onClick={() => onArchive(acc)} className="p-1 bg-yellow-200 rounded-full text-yellow-800 hover:bg-yellow-300"><svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M8 4H6a2 2 0 00-2 2v12a2 2 0 002 2h12a2 2 0 002-2V6a2 2 0 00-2-2h-2m-4-1v8m0 0l3-3m-3 3L9 8m-5 5h12" /></svg></button>
            </div>
            {acc.accountType === 'savings' && <SavingsGoals account={acc} onAddGoal={onAddGoal} onAddFunds={onAddFunds} />}
        </div>
    );

    return (
        <div className="bg-white p-6 rounded-lg shadow space-y-6">
            <div>
                <h2 className="text-xl font-semibold mb-4">Debit Accounts</h2>
                {debitAccounts.length > 0 ? (<div className="grid grid-cols-1 md:grid-cols-2 gap-4">{debitAccounts.map(acc => <AccountCard key={acc.id} acc={acc} />)}</div>) : (<p className="text-gray-500">No debit accounts found.</p>)}
            </div>
            <hr />
            <div>
                <h2 className="text-xl font-semibold mb-4">Credit Accounts</h2>
                {creditAccounts.length > 0 ? (<div className="grid grid-cols-1 md:grid-cols-2 gap-4">{creditAccounts.map(acc => <AccountCard key={acc.id} acc={acc} />)}</div>) : (<p className="text-gray-500">No credit accounts found.</p>)}
            </div>
            <hr />
            <div>
                <h2 className="text-xl font-semibold mb-4">Savings Accounts</h2>
                {savingsAccounts.length > 0 ? (<div className="grid grid-cols-1 md:grid-cols-2 gap-4">{savingsAccounts.map(acc => <AccountCard key={acc.id} acc={acc} />)}</div>) : (<p className="text-gray-500">No savings accounts found.</p>)}
            </div>
        </div>
    );
};

export default AccountBalances;